// Função para validar extensões de arquivos permitidas
export const validarExtensionArchivo = (arquivo) => {
  // Extensões permitidas definidas no sistema
  const extensoesPermitidas = process.env.REACT_APP_EXTENSOES_PERMITIDAS.split(',');

  // Obter a extensão do arquivo
  const nomeArquivo = arquivo.name;
  const extensao = nomeArquivo.split('.').pop().toLowerCase();
  
  // Verificar se a extensão está na lista de permitidas
  return extensoesPermitidas.includes(extensao);
};

// Função para validar múltiplos arquivos
export const validarArchivos = (arquivos) => {
  const arquivosInvalidos = [];
  
  arquivos.forEach((arquivo, index) => {
    if (!validarExtensionArchivo(arquivo)) {
      arquivosInvalidos.push({
        nome: arquivo.name,
        indice: index
      });
    }
  });
  
  return {
    todosValidos: arquivosInvalidos.length === 0,
    arquivosInvalidos: arquivosInvalidos
  };
};

// Função para obter a mensagem de erro de validação
export const obterMensagemErroValidacao = (arquivosInvalidos) => {
  if (arquivosInvalidos.length === 0) {
    return '';
  }
  
  const nomesInvalidos = arquivosInvalidos.map(arquivo => arquivo.nome).join(', ');
  const extensoesPermitidas = process.env.REACT_APP_EXTENSOES_PERMITIDAS;

  
  return `Os seguintes arquivos possuem extensões não permitidas: ${nomesInvalidos}. ` +'\n' +
         `Extensões permitidas: ${extensoesPermitidas}`;
};
